import { Component, Inject, Input, OnInit } from '@angular/core';
import { Sim } from 'libs/portal/src/models/Sim';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { ToastrService } from 'ngx-toastr';
import { ConfirmReasonModalComponent } from '../confrim-reason-modal/confirm-reason-modal.component';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { RadiusSimBlockResp } from 'libs/portal/src/models/RadiusSimBlockResp.model';
import { ActivatedRoute } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-device-sim-info',
  templateUrl: './device-sim-info.component.html',
  styleUrls: ['./device-sim-info.component.scss'],
})
export class DeviceSimInfoComponent implements OnInit {
  @Input() sim: Sim;

  canDisableSims: boolean = false;
  radiusLive: boolean = false;
  checkingRadiusState: boolean = false;

  screenSize = ScreenSize;
  modalStyle: string = this.layoutService.screenSize > this.screenSize.MOBILE_L ? 'auto-height' : '';

  constructor(
    private params: ActivatedRoute,
    private layoutService: LayoutService,
    private genericService: GenericService,
    private endpoints: Endpoints,
    private toastService: ToastrService,
    private userService: UserRightsService,
    private dialogRef: MatDialogRef<DeviceSimInfoComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: Sim,
    private dialog: MatDialog,
  ) {
    this.checkIfRadiusIsLive();
  }

  ngOnInit() {
    if (this.dialogData != null) {
      this.sim = this.dialogData as Sim;
    }

    this.canDisableSims = (this.userService.GetUserAccessRoles().IsSuperUser() || this.userService.IsHugeAdmin() || this.userService.GetUserAccessRoles().IsCDRAdmin()) && this.userService.GetUserPortalReadWrite().PortalWriteAccess;
  }

  closeModal() {
    this.dialogRef.close();
  }

  checkIfRadiusIsLive() {
    this.checkingRadiusState = true;
    this.genericService.GET(this.endpoints.GET_RADIUS_SERVER_STATUS).subscribe({
      next: (val) => {
        if (val['body'] === true) {
          this.radiusLive = true;
        } else {
          this.radiusLive = false;
        }
        this.checkingRadiusState = false;
      },
      error: (_) => {
        this.radiusLive = false;
        this.checkingRadiusState = false;
      },
    });
  }

  async blockSim() {
    const dialogRefI = this.dialog.open(ConfirmReasonModalComponent, {
      data: {
        message: `Are you sure that you want to ${this.sim.Disabled || this.sim['Status'] == 'Network Blocked' ? 'unblock' : 'block'} this sim?`,
      },
      panelClass: this.modalStyle,
    });

    let dialogSub = dialogRefI.afterClosed().subscribe({
      next: (dataReturned) => {
        console.log(dataReturned)
        if (dataReturned?.confirmed === true) {
          this.checkingRadiusState = true;
          this.genericService
            .POST(this.endpoints.UPDATE_SIM_BLOCKED_STATUS, {
              SimID: this.sim.SimID,
              Blocked: !(this.sim.Disabled || this.sim['Status'] == 'Network Blocked'),
              Reason: dataReturned.reason,
            })
            .subscribe({
              next: (resp: any) => {
                let res: RadiusSimBlockResp = resp.body;
                let successful: boolean = true;
                this.sim.APNInfo = res.APNInfo;
                res.APNInfo.forEach((val) => {
                  if (val.Error != null && val.Error != '') {
                    successful = false;
                    this.toastService.error(val.Error, 'Unable to update APN: ' + val.RadiusName, {
                      timeOut: 1000,
                    });
                  }
                });
                if (successful) {
                  this.toastService.success('', 'Successfully updated sim status', { timeOut: 1000 });
                  this.sim.Disabled = !this.sim.Disabled;
                }
                if (this.sim.Disabled) {
                  this.sim.StatusChangeTimestamp = new Date();
                }
                this.checkingRadiusState = false;
                this.dialogRef.close(this.sim);
              },
            });
        } else {
          this.checkingRadiusState = false;
        }
        dialogSub.unsubscribe();
      },
    });
  }
}
